export default {
  /**
   * The number of total Github contributions.
   * 
   * @param {Number}
   */
  contributions: 0
}